// export const API_BASE_URL = 'https://crmapi.ifbsupport.com/api/v1/cut-app'
// export const API_BASE_URL = 'http://192.168.52.82:8087/api/v1/cut-app'
export const API_BASE_URL = 'https://devtcrmapi.ifbsupport.com/api';
export const GET_LOYALTY_POINTS_URL = `https://api.ifbanalytics.com/v1/MKT/get_reward`;
export const UPDATE_LOYALTY_POINTS_URL = `https://api.ifbanalytics.com/v1/MKT/reward`;
export const GET_AMC_CONTRACTS_URL = `${API_BASE_URL}/service-contract/contract-type`;
export const GET_TOP_SELLING_URL = `${API_BASE_URL}/v1/cut-app/topSaleItems/ESS`;
export const UPDATE_COORDS_URL = `${API_BASE_URL}/v1/myifb/add-coordinates`;
export const GET_APPOINTMENT_DETAILS_URL = `https://api.ifbanalytics.com/v1/CRM/appt_verify`;
export const CONFIRM_APPOINTMENT_URL = `https://api.ifbanalytics.com/v1/CRM/update_appt_new`;
export const FEEDBACK_APPOINTMENT_URL = `https://api.ifbanalytics.com/v1/CRM/check_visit_new`;
export const ADD_CART_ITEM_URL = `${API_BASE_URL}/cart/add-items`;
export const MAP_API_KEY = `AIzaSyB5pgtUCkQov3pXa7NlHYPSQ9PA9tyg3to`;

// New APIs
// export const NEW_BASE_URL = 'https://192.168.52.91/cxapp/api/product/v1';
export const NEW_BASE_URL = 'https://cxapp-sales-qas.ifbsupport.com/cxapp/api/product/v1';
export const GET_TOP_RATED_BASE_URL = (cat = '0', subcat = '0', query = '0') =>
  `${NEW_BASE_URL}/toprated/get?cat=${cat}&subcat=${subcat}&query=${query}`;
export const GET_PRODUCT_DETAIL_URL = `${NEW_BASE_URL}/productdetails/get`;
export const GET_ETA_URL = `${NEW_BASE_URL}/deliverytime/get`;
export const FETCH_CART_ITEMS_URL = `${NEW_BASE_URL}/fetchitems/get`;
export const INSERT_CART_ITEM_URL = `${NEW_BASE_URL}/cartdetails/insert`;
export const DELETE_CART_ITEM_URL = `${NEW_BASE_URL}/cartdetails/delete`;
export const GET_CART_ITEMS_URL = `${NEW_BASE_URL}/fetchitems/get`;
export const UPDATE_CART_ITEM_URL = `${NEW_BASE_URL}/cartdetails/insert`;
export const DELETE_DELIVERY_DETAILS = `${NEW_BASE_URL}/deliverydetails/delete`;
export const FETCH_DELIVERY_DETAILS = `${NEW_BASE_URL}/deliverydetails/get`;
export const INSERT_DELIVERY_DETAILS = `${NEW_BASE_URL}/deliverydetails/insert`;
export const SET_DEFAULT_DETAILS = `${NEW_BASE_URL}/setaddress/select`;
export const GET_ALL_ORDERS = `${NEW_BASE_URL}/orderdetails/get`;
export const WISHLIST_INSERT = `${NEW_BASE_URL}/wishlistdetails/insert`;
export const WISHLIST_DELETE = `${NEW_BASE_URL}/wishlistdetails/delete`;
export const GET_WISHLIST_LIST = (userId: string | number) =>
  `${NEW_BASE_URL}/fetchitems/wishlist/get?user=${userId}`;
export const GET_SINGLE_ORDER = `${NEW_BASE_URL}/single/orderdetails/get`;
export const PLACE_ORDER = `${NEW_BASE_URL}/orderdetails/insert`;
export const SUBMIT_REVIEW_URL = `${NEW_BASE_URL}/product/review/insert`;
export const IMAGE_URL_PREFIX = 'https://clientapi.ifbsupport.com/images/';
export const INVOICE_URL_PREFIX = `${NEW_BASE_URL}/invoice/Download`;
export const GENERATE_HASH_URL = `${NEW_BASE_URL}/payu/generate/hash`;
export const GET_OFFERS_URL = `${NEW_BASE_URL}/fetch/offers/get`;
export const GET_ORDER_AGAIN_URL = (userId: string) =>
  `${NEW_BASE_URL}/orderagain/get?user=${userId}`;

// export const FAILURE_URL = SUCCESS_URL;
export const FRONT_END_URL = 'http://localhost:3000';
export const SUCCESS_URL = `${NEW_BASE_URL}/payu/generate/redirect?status=success&txnid=`;
export const FAILURE_URL = `${NEW_BASE_URL}/payu/generate/redirect?status=failure&txnid=`;

export const GET_AMC_PRICE_URL = (
  FGCode: string,
  ContractTypeCode: string,
  AMCTypeCode: string,
  DiscountAmount: string,
) =>
  `${API_BASE_URL}/v1/cut-app/service-contract/price/base-price?FGCode=${FGCode}&ContractTypeCode=${ContractTypeCode}&AMCTypeCode=${AMCTypeCode}&DiscountAmount=${DiscountAmount}`;

export const GET_REASONS_URL = (productCode: string) =>
  `https://crmapi.ifbsupport.com/api/wa/problem-categories/?ProductCode=${productCode}`;

export const GET_DETAILS_BY_PINCODE_URL = (pincode: string) =>
  `https://crmapi.ifbsupport.com/api/wa/find-area?PinCode=${pincode}`;

export const CLIENT_BASE_URL = 'https://clientapi.ifbsupport.com/api/v1';
export const GET_MEDIA_URL = (
  cat: 'BANNER' | 'TESTIMONIAL',
  type: 'HOMESCREEN' | 'CAROUSEL' | 'VIDEO',
) => {
  const url = new URL(`${CLIENT_BASE_URL}/SiteImages/site/images/get`);
  url.searchParams.set('cat', cat);
  url.searchParams.set('type', type);
  return url.toString();
};
export const GENERATE_OTP_URL = `${CLIENT_BASE_URL}/Auth/generate-otp`;
export const VERIFY_OTP_URL = `${CLIENT_BASE_URL}/Auth/validate-otp`;
export const GET_ACCOUNT_INFO_URL = `${CLIENT_BASE_URL}/myIFB/getManageAccount`;
export const GET_TICKET_STATUS_URL = `${CLIENT_BASE_URL}/myIFB/getTicketStatus`;
export const GET_ESCLATION_STATUS_INFO_URL = `${CLIENT_BASE_URL}/myIFB/escalated-tickets`;
export const GET_ESCALATION_REASONS_URL = `${CLIENT_BASE_URL}/myIFB/escalation/reasons`;
export const REQUEST_ESCALATION_URL = `${CLIENT_BASE_URL}/myIFB/request-creation`;
export const CREATE_TICKET_URL = `${CLIENT_BASE_URL}/MyService/request/add`;
export const GET_BANNER_URL = `${CLIENT_BASE_URL}/myIFB/get-banners/`;
